export default "__VITE_ASSET__qrKxiU$y__"